import { CommonGetOptions } from "interfaces/dataInterfaces"
import { householdApi } from "./householdApi"

export const categoriesApi = householdApi.injectEndpoints({
  endpoints: builder => ({
    getAllCategories: builder.query<CommonGetOptions[], void>({
      query: () => ({
        url: `SurveyCategories/Get`,
        method: "GET",
      }),
      providesTags: ["Categories"],
    }),

    addCategory: builder.mutation<void, { name: string }>({
      query: ({ name }) => ({
        url: `SurveyCategories/Add`,
        method: "POST",
        params: { name },
      }),
      invalidatesTags: ["Categories"],
    }),

    editCategory: builder.mutation<void, { id: number; name: string }>({
      query: ({ id, name }) => ({
        url: `SurveyCategories/Put/${id}`,
        method: "PUT",
        params: { name },
      }),
      invalidatesTags: ["Categories"],
    }),

    deleteCategory: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `SurveyCategories/Delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Categories"],
    }),
  }),
})

export const {
  useGetAllCategoriesQuery,
  useLazyGetAllCategoriesQuery,
  useAddCategoryMutation,
  useEditCategoryMutation,
  useDeleteCategoryMutation,
} = categoriesApi
